import React, { useEffect, useMemo, useRef, useState } from "react";
import JoditEditor from "jodit-react";
import Terms from "./Section/Terms";
import Privacy from "./Section/Privacy";
import Trand from "./Section/Trand";
import Outfits from "./Section/OutFit";
import { toastMessage } from "utils/toastMessage";
import { getContentApi, updateContentApi } from "services/cms";
import useFullPageLoader from "common/UseFullPageLoader";
import useButtonLoader from "common/UseButtonLoader";
import { CustomTab, CustomTabs } from "components/tabs/Tabs";
import CustomButton from "components/form";
import "./ContentManagement.scss";

const ContentManagement = () => {
  const [type, setType] = useState("terms");
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useButtonLoader("Update");
  const [cmsData, setCmsData] = useState("");
  const [errorField, setErrorField] = useState("");
  const editorRef = useRef(null);

  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: " ",
      toolbar: true,
      spellcheck: true,
      language: "en",
      toolbarButtonSize: "medium",
      showCharsCounter: true,
      showWordsCounter: true,
      showXPathInStatusbar: false,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      uploader: {
        insertImageAsBase64URI: true,
      },
    }),
    []
  );

  // Validation for empty content
  const handleValidation = () => {
    if (!cmsData || cmsData.trim().length === 0) {
      setErrorField("Please enter content");
      return false;
    }
    setErrorField("");
    return true;
  };

  // Fetch CMS details for the selected tab
  const getCmsDetails = async (currentType = type) => {
    try {
      showLoader();
      const res = await getContentApi({ type: currentType });
      if (res?.data?.status === 200) {
        setCmsData(res.data?.data.cms?.description || "");
      } else {
        setCmsData("");
        toastMessage(res.message, "error");
      }
    } catch (err) {
      toastMessage(err, "error");
    } finally {
      hideLoader();
    }
  };

  // Handle content update
  const updateCmsHandler = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      const payload = {
        type: type,
        description: cmsData,
      };
      try {
        setSubmitLoading(true);
        const res = await updateContentApi(payload);
        if (res.data.status === 200) {
          toastMessage("Content updated successfully!");
        } else {
          toastMessage(res.data.message, "error");
        }
      } catch (err) {
        toastMessage(err, "error");
      } finally {
        setSubmitLoading(false);
      }
    }
  };

  // Fetch content when the tab changes
  useEffect(() => {
    getCmsDetails(type);
  }, [type]);

  return (
    <div className="content_management">
      {loader}
      <div className="card mb-2">
        <div className="dashboard_title has_child">
          <h3>CMS Management</h3>
          <CustomButton onClick={updateCmsHandler} ref={submitButtonElement}>
            Update
          </CustomButton>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="tabButton">
            <CustomTabs
              value={type}
              onChange={(e, section) => {
                setType(section);
              }}
              aria-label="Content"
              variant="fullWidth"
            >
              <CustomTab value="terms" label="Terms & Conditions" />
              <CustomTab value="policy" label="Privacy Policy" />
              <CustomTab value="about" label="About us"/>
              {/* <CustomTab value="outfits" label="Outfits" /> */}
            </CustomTabs>
          </div>
          {/* JoditEditor Integration */}
          <div className="text_editor_wrap">
            <JoditEditor
              ref={editorRef}
              value={cmsData}
              config={config}
              onBlur={(content) => setCmsData(content)}
            />
            {errorField && (
              <div className="text-danger" style={{ fontSize: "0.875em" }}>
                {errorField}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ContentManagement;
